module.exports = __webpack_public_path__ + "static/images/ico-numberbox@2x.cda2ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/ico-numberbox@2x.png
// module id = rHAk
// module chunks = 6 7